import { createApp, ref } from "vue";
import "./polyfills";
import "./plugins/vant";
import "@/utils/mapvgl";
import "@/assets/styles/index.less";
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont/iconfont.js";

import router from "./router";
import store from "@/store/store";
import "@/router/permission";
import dayjs from "@/plugins/day";
import matomo from "@/plugins/vue-matomo";
import "virtual:svg-icons-register";
import VConsole from "vconsole";
import directive from "@/directives";
import SvgIcon from "@/component/svg-icon/index";
import iconfont from "@/component/iconfont/index";
import LoadImage from "@/component/load-image.vue";
import ScrollList from "@/component/scroll-list";
import PreviewFile from "@/component/preview-file";
import RadioGroups from "@/component/radio-group";
import FrontLabel from "@/component/front-label/index.vue";
import { Lazyload } from "vant";
import VueKonva from "vue-konva";

import App from "./App.vue";
const cApp = createApp(App);

cApp.config.globalProperties.dayjs = dayjs;

// if (import.meta.env.MODE === "development" || import.meta.env.MODE === "staging") {
new VConsole({ theme: "dark" });
// }

cApp
  .use(store)
  .use(router)
  .use(SvgIcon)
  .use(Lazyload)
  .use(VueKonva)
  .use(iconfont)
  .component("front-label", FrontLabel)
  .component("load-image", LoadImage)
  .use(ScrollList)
  .use(PreviewFile)
  .use(RadioGroups)
  .use(directive);
cApp.mount("#app");

if ((window.VITE_APP_MATOMO_SID && window.VITE_APP_MATOMO_ADD) || import.meta.env.VITE_APP_MATOMO_SID || import.meta.env.VITE_APP_MATOMO_ADD) {
  matomo(cApp, router);
}
window.ref = ref;
